/**
 * Table body Link组件
 */

import { Button } from '@tencent/udesign/dist';
import { openURL } from '../../../../../lib';
import { log } from '../../../libs';
import { IFieldValueExtensionLink, IValue } from '../../../model';

interface IPropsButtonLink {
  readonly selectedValue: IValue;
  readonly className?: string;
}
export const DynamicButtonLink = (props: IPropsButtonLink) => {
  const { value } = props.selectedValue;
  let data: IFieldValueExtensionLink;
  try {
    data = typeof value === 'string' ? JSON.parse(value) : value;
  } catch (err) {
    log.error(err);
    return <span>-</span>;
  }
  const onClickLink = () => {
    try {
      openURL(data.url);
    } catch (err) {}
  };

  if (data) {
    return (
      <Button
        type="primary"
        style="link"
        className={props.className}
        onClick={onClickLink}
      >
        {data.value}
      </Button>
    );
  }
  return null;
};
